<template>
<!-- <div id="sticky-nav" class="wrapper" > -->
  <div class="wrapper-nav">
  <!-- <div class="count-down-num" > -->
    <div :class="navClass" :style="`height:${showNavH}px`" >
      <span class="hideTipView">{{getViodModel(variInfo)}}</span>
    </div>
  </div>
</template>

<script>
import JS from '@/base/JSTool';
import stickybits from 'stickybits';
import NativeMsg from '@/base/NativeMsg';
import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import { throttle } from '@fund/basic-lib/dist/lib/function';
import {
  setNavBarColor,
  navBack,
  setNavTitle,
  setNavFundTitle,
  getIsweb50Sys,
  getIs50Sys,
} from '@/utils/nativeBridge';

import { mapGetters } from 'vuex';

export default {
  mounted() {
    stickybits('#sticky-nav');
    if (!getIsweb50Sys()) {
      const div = document.querySelector('#mainBankImage');
      if (div) {
        div.style['background-image'] = 'linear-gradient(#f5f5f5, #f5f5f5 112px, #f5f5f5)';
      }

      const divbody = document.querySelector('#mainbody');
      if (divbody) {
        divbody.style.background = '#f5f5f5';
      }
      console.log('zxy ---- shezhi');
    }
  },
  computed: {
    ...mapGetters({
      variInfo: 'currentFundVarietyByFundInfo',
    }),
  },
  data() {
    return {
      showType: 0,
      lastShowType: 0,
      navTitleType: 0,
      showNavH: 0,
      navH: 0,
      cansetNav: false,
      hasSetNav: false,
      hasSetBackColor: false,
      hasSetBackClear: false,
      navClass: 'nav-white',
      normalTitleItem: null,
      showCLick: false,
    };
  },
  created() {
    if (!getIs50Sys()) {
      const div = document.querySelector('#mainBankImage');
      if (div) {
        div.style['background-image'] = 'linear-gradient(#f5f5f5, #f5f5f5 112px, #f5f5f5)';
      }

      const divbody = document.querySelector('#mainbody');
      if (divbody) {
        divbody.style.background = '#f5f5f5';
      }
      console.log('zxy ---- shezhi');
      return;
    }
    this.configureLayout();
    this.render();
    NativeMsg.reg('refreshBarbtn', () => {
      this.setTopNav();
    });
    NativeMsg.reg('onPageShow', () => {
      const { fundCode, oldFundCode } = this.$store.state.native.fund;
      let code = fundCode;
      if (oldFundCode) {
        // eslint-disable-next-line no-param-reassign
        code = oldFundCode;
      }
      setNavBarColor({
        backgroundColor: '#E93801',
        fundCode: code,
        subTitleColor: '#ffffff',
        frontColor: '#ffffff',
        // statusBarStyle: 'white',
      });
      this.cansetNav = true;
      if (this.hasSetNav) {
        this.showTopViewType(this.showType, true);
        this.configureNavBackColor();
        const item = {
          title: '基金详情',
          subTitle: '',
          subTitleColor: '#000000',
        };
        this.setTitleWithfundCode(item);
      } else {
        this.render();
        const item = {
          title: '基金详情',
          subTitle: '',
          subTitleColor: '#000000',
          videoData: null,
          mtype: 1,
        };
        this.setTitleWithfundCode(item);
      }
      this.configureNavBackColor();
      this.showMark();
    });
  },
  methods: {
    showMark() {
    },
    configureNavBackColor() {
      let redB = false;
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        redB = true;
      }
      if (baseInfo) {
        if (baseInfo.TSRQ) {
          const endDate = new Date(baseInfo.TSRQ.replace(/-/g, '/')).getTime();
          const serverDate = new Date().getTime();
          if (serverDate > endDate) {
            redB = false;
          } else {
            redB = true;
          }
        }
      }
      const { fundCode, oldFundCode } = this.$store.state.native.fund;
      let code = fundCode;
      if (oldFundCode) {
        // eslint-disable-next-line no-param-reassign
        code = oldFundCode;
      }
      if (document.visibilityState === 'visible') {
        if (redB) {
          setNavBarColor({
            backgroundColor: '#E93801',
            fundCode: code,
            subTitleColor: '#ffffff',
            frontColor: '#ffffff',
            statusBarStyle: 'white',
          });
        } else {
          setNavBarColor({
            backgroundColor: '#999999',
            fundCode: code,
            subTitleColor: '#ffffff',
            frontColor: '#ffffff',
            statusBarStyle: 'white',
          });
        }
      }
    },
    configureNowTitle() {
      if (!getIs50Sys()) {
        return;
      }
      this.showTopViewType(this.showType, true);
      const item = {
        title: '基金详情',
        subTitle: '',
        subTitleColor: '#000000',
      };
      this.setTitleWithfundCode(item);
      this.configureNavBackColor();
    },
    // 高度适配
    configureLayout() {
      this.navH = StoreManger.getNAVSTATEHEIGHT();
    },
    getViodModel() {
      this.showTopViewType(this.showType, true);
      return '';
    },
    render() {
      console.log('nav render');
      const { fundCode, fundType } = this.$store.state.native.fund;
      console.log(`nav render${fundCode}`);
      const baseInfo = StoreManger.getFundJJXQ();
      this.hbandpgshowtype(baseInfo, fundType, true);
      this.configureNowTitle();
      this.showWhiteNav();
      this.lastShowType = this.showType;
    },
    hbandpgshowtype(baseInfo, fundType, setNav) {
      if (!baseInfo) {
        this.showTopViewType(1);
        return;
      }
      const endDate = new Date(baseInfo.TSRQ.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();
      if (serverDate > endDate) {
        this.showTopViewType(3, setNav);
        return;
      }
      this.showTopViewType(1, setNav);
    },
    setTopNav() {
      const { fundType } = this.$store.state.native.fund;
      const baseInfo = StoreManger.getFundJJXQ();
      this.hbandpgshowtype(baseInfo, fundType, true);
    },
    showWhiteNav() {
      this.hasSetNav = true;
    },
    showNormalNav() {
      this.hasSetNav = true;
      if (this.lastShowType !== this.showType) {
        this.render();
      }
    },
    setTitleWithfundCode(item) {
      const { fundCode, oldFundCode } = this.$store.state.native.fund;
      if (fundCode) {
        // eslint-disable-next-line no-param-reassign
        item.fundCode = fundCode;
      }
      if (oldFundCode) {
        // eslint-disable-next-line no-param-reassign
        item.fundCode = oldFundCode;
      }

      // 退市处理
      if (this.showType === 3) {
        // eslint-disable-next-line no-param-reassign
        item.title = '基金已退市';
        // eslint-disable-next-line no-param-reassign
        item.subTitle = '';
        // eslint-disable-next-line no-param-reassign
        item.subTitleColor = '#000000';
      }
      // eslint-disable-next-line no-param-reassign
      item.titleColor = '#ffffff';
      setNavTitle(item).then(() => {
      }).catch(() => {
      });
    },

    clearNavTitle() {
      if (!getIs50Sys()) {
        return;
      }
      this.showNavH = 0;
      if (this.navTitleType === 1) {
        this.navTitleType = 0;
        const item = {
          title: '基金详情',
          subTitle: '',
          subTitleColor: '#000000',
        };
        this.setTitleWithfundCode(item);
      }
      this.showNormalNav();
    },
    getValueStrWithKey(item, key) {
      const res = JS.fetchString(item, key);
      if (res === '-') {
        return '--';
      }
      return res || '--';
    },
    configureBodyBack(index) {
      if (index > 210) {
        const divbody = document.querySelector('#mainbody');
        if (divbody) {
          divbody.style.background = '#f5f5f5';
        }
      } else {
        const divbody = document.querySelector('#mainbody');
        if (divbody) {
          if (this.showType === 3) {
            divbody.style.background = '#999999';
          } else {
            divbody.style.background = '#E93801';
          }
        }
      }
    },
    // eslint-disable-next-line
    throttleConfigureNavBackColor:throttle (
      function throttleConfigureNavBackColor() {
        this.configureNavBackColor();
      },
      60000,
      { trailing: false },
    ),
    setNomalNavMove(index) {
      if (!getIs50Sys()) {
        return;
      }
      this.configureBodyBack(index);
      this.throttleConfigureNavBackColor();
    },
    setNomalNavTitle() {
      if (!getIs50Sys()) {
        return;
      }
      this.showNavH = this.navH;
      this.showWhiteNav();
      const { fundType } = this.$store.state.native.fund;
      this.navTitleType = 1;
      if (this.normalTitleItem) {
        this.setTitleWithfundCode(this.normalTitleItem);
        if (getIs50Sys()) {
          this.setNavIOSAllPage(this.normalTitleItem);
        }
      } else {
        if (FundTypeSearch.isNewFund(fundType)) {
          this.normalTitleItem = this.getXFUpTitleData();
        } else if (FundTypeSearch.isMonetaryfund(fundType)) {
          this.normalTitleItem = this.getHBUpTitleData();
        } else if (FundTypeSearch.isExchangeFund(fundType)) {
          this.normalTitleItem = this.getCNUpTitleData();
        } else {
          this.normalTitleItem = this.getPGUpTitleData();
        }
        this.setTitleWithfundCode(this.normalTitleItem);
        if (getIs50Sys()) {
          this.setNavIOSAllPage(this.normalTitleItem);
        }
      }
    },
    setNavIOSAllPage(item) {
      // 现在怀疑页面翻页时有定位问题，fund方法不判断select fund ，直接全部设置掉
      const { fundCode, oldFundCode } = this.$store.state.native.fund;
      if (fundCode) {
        // eslint-disable-next-line no-param-reassign
        item.fundCode = fundCode;
      }
      if (oldFundCode) {
        // eslint-disable-next-line no-param-reassign
        item.fundCode = oldFundCode;
      }

      // 退市处理
      if (this.showType === 3) {
        // eslint-disable-next-line no-param-reassign
        item.title = '基金已退市';
        // eslint-disable-next-line no-param-reassign
        item.subTitle = '';
        // eslint-disable-next-line no-param-reassign
        item.subTitleColor = '#000000';
      }
      // eslint-disable-next-line no-param-reassign
      item.titleColor = '#ffffff';
      setNavFundTitle(item).then(() => {
      }).catch(() => {
      });
    },
    getCNUpTitleData() {
      const { fundCode } = this.$store.state.native.fund;
      const baseInfo = StoreManger.getFundJJXQ();
      const newmarket = this.getValueStrWithKey(baseInfo, 'NEWTEXCH');
      const fundin = `${newmarket}.${fundCode}`;
      const stokeinfo = this.$store.state.stokeinfo.fund[fundin];
      const Close = this.getValueStrWithKey(stokeinfo, 'f43');
      let Change = this.getValueStrWithKey(stokeinfo, 'f169');
      if (Change === '0') {
        Change = parseFloat(Change).toFixed(3);
      }
      let ChangePercent = this.getValueStrWithKey(stokeinfo, 'f170');
      if (ChangePercent === '0') {
        ChangePercent = parseFloat(ChangePercent).toFixed(2);
      }
      const {
        SHORTNAME,
      } = baseInfo;
      if (ChangePercent !== '--') {
        if (parseFloat(ChangePercent).toFixed(2) > 0) {
          ChangePercent = `+${parseFloat(ChangePercent).toFixed(2)}%`;
        } else {
          ChangePercent = `${parseFloat(ChangePercent).toFixed(2)}%`;
        }
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${Close} ${Change} ${ChangePercent}`,
        frontColor: '#ffffff',
        subTitleColor: '#ffffff',
      };
      return navData;
    },
    getHBUpTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        DWJZ, LJJZ, SHORTNAME,
      } = baseInfo;
      let zdf = '--';
      if (LJJZ && LJJZ !== '--') {
        if (parseFloat(LJJZ).toFixed(4) > 0) {
          zdf = `+${parseFloat(LJJZ).toFixed(4)}%`;
        } else {
          zdf = `${parseFloat(LJJZ).toFixed(4)}%`;
        }
      }
      let wfsy = JS.fetchString(baseInfo, 'DWJZ');
      if (wfsy && wfsy !== '--') {
        wfsy = `${parseFloat(DWJZ).toFixed(4)}`;
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${wfsy}   ${zdf}`,
        frontColor: '#ffffff',
        subTitleColor: '#ffffff',
      };
      return navData;
    },
    getXFUpTitleData() {
      const { fundCode } = this.$store.state.native.fund;
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        SHORTNAME,
      } = baseInfo;
      const navData = {
        title: SHORTNAME,
        subTitle: `${fundCode}`,
        frontColor: '#ffffff',
        subTitleColor: '#ffffff',
      };
      return navData;
    },
    getPGUpTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        return {
          title: '基金详情',
          subTitle: '',
          subTitleColor: '#ffffff',
          frontColor: '#ffffff',
        };
      }
      const {
        DWJZ, RZDF, SHORTNAME,
      } = baseInfo;
      let zdf = '--';
      if (RZDF && RZDF !== '--') {
        if (parseFloat(RZDF).toFixed(2) > 0) {
          zdf = `+${parseFloat(RZDF).toFixed(2)}%`;
        } else {
          zdf = `${parseFloat(RZDF).toFixed(2)}%`;
        }
      }
      let dwjzStr = '--';
      if (DWJZ && DWJZ !== '--') {
        dwjzStr = `${parseFloat(DWJZ).toFixed(4)}`;
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${dwjzStr}   ${zdf}`,
        subTitleColor: '#ffffff',
        frontColor: '#ffffff',
      };
      return navData;
    },

    showTopViewType(type, setNav) {
      NativeMsg.post(JSON.stringify({ key: 'refreshBarbtnSp', value: { type } }));
      // 默认0 白色 1涨 2跌 3平
      if (type === 1) {
        this.showType = 1;
        this.navClass = 'nav-red';
        this.changeNavleftAndLeft(0, setNav);
      }
      if (type === 2) {
        this.showType = 2;
        this.navClass = 'nav-green';
        this.changeNavleftAndLeft(0, setNav);
      }
      if (type === 3) {
        this.showType = 3;
        this.navClass = 'nav-grey';
        this.changeNavleftAndLeft(0, setNav);
        if (getIsweb50Sys()) {
          const div = document.querySelector('#mainBankImage');
          if (div) {
            div.style['background-image'] = 'linear-gradient(#999999, #f5f5f5 112px, #f5f5f5)';
          }

          const divbody = document.querySelector('#mainbody');
          if (divbody) {
            divbody.style.background = '#999999';
          }
        }
      }
      if (type === 0) {
        this.showType = 0;
        this.navClass = 'nav-white';
        this.changeNavleftAndLeft(1, setNav);
      }
    },
    setNavBarVtn(name, params, callback) {
      // #if EXECUTION_ENV === 'web'
      console.log(`调用原生${name}方法，参数：`, params);
      // #elif EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (!fundDetail[name]) {
        console.warn(`fundDetail 没有 ${name} 方法`);
        callback(null, '');
        return;
      }
      // eslint-disable-next-line no-undef
      fundDetail[name]({
        ...params,
        success: (res) => {
          callback(res, null);
        },
        fail: (err) => {
          callback(err, null);
        },
      });
      // #endif
    },

    getCache(key) {
      return window.localStorage.getItem(key);
    },
    videoClickAction() {
      this.videoThrottleClickAction();
    },
    // eslint-disable-next-line
    videoThrottleClickAction: throttle (
      function videoThrottleClickAction() {
        const { fundCode } = this.$store.state.native.fund;
        if (!(this.getCache(`video${fundCode}`) === '1')) {
          console.log('hiddenvideo');
          NativeMsg.post(JSON.stringify({ key: 'hiddenvideo', value: { hidden: '1' } }));
          NativeMsg.post(JSON.stringify({ key: 'scrollToVideo', value: { } }));
        } else {
          //
          NativeMsg.post(JSON.stringify({ key: 'scrollToVideo', value: { } }));
          NativeMsg.post(JSON.stringify({ key: 'hiddenvideo', value: { hidden: '0' } }));
        }
      },
      1000,
      { trailing: false },
    ),
    changeNavleftAndLeft(type, setNav) {
      if (!setNav) {
        return;
      }
      const { fundCode } = this.$store.state.native.fund;
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        return;
      }
      //
      // eslint-disable-next-line no-undef
      this.setNavBarVtn('setNavigationBar', {
        fundCode,
        items: [
          {
            text: '\ue666',
            fontSrc: '/static/iconfont.ttf',
            float: 'left',
            width: '48px',
            color: '#ffffff',
          },
          {
            text: '\ue66C',
            fontSrc: '/static/iconfont.ttf',
            float: 'right',
            width: '48px',
            color: '#ffffff',
          },
        ],
      }, (res) => {
        if (res) {
          if (res.index === 0) {
            navBack({});
          }
          if (res.index === 1) {
            // navBack({});
            NativeMsg.post(JSON.stringify({ key: 'share', value: {} }));
          }
          if (res.index === 2) {
            this.videoClickAction();
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper-nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  width: 100%;
  align-items: center;
}
.nav-white {
  background-color: #E93801;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
}
.nav-red {
  background-color: #E93801;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
}
.nav-green {
  background-color: #E93801;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
}
.nav-grey {
  background-color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
}
.bottom-line{
  margin-left: 25px;
  margin-right: 25px;
}
.tab {
  display: flex;
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
//   line-height: 88px;
  // height: 88px;
}
.hideTipView{
  color: #000;
}
.tabB {
  position: relative;
  top: 10px;
  width: 30px;
  height: 6px;
  border-radius: 3px;
}
.tab-selected {
}
.tabB-selected {
  background-color: #ff4400;
}
.nav-link {
  color: #000;
  text-decoration: none;
  // line-height: 88px;
}
.tab-selected .nav-link {
  color: #000!important;
  font-weight: bold;
}
</style>
